/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * TSOA-friendly automatic assignment strategy used by the MeLi sync endpoint.
 */
export type MeliItemSyncImportAssignmentAuto = {
    /**
     * Assignment mode.
     */
    mode: MeliItemSyncImportAssignmentAuto.mode;
};
export namespace MeliItemSyncImportAssignmentAuto {
    /**
     * Assignment mode.
     */
    export enum mode {
        AUTO = 'auto',
    }
}

